const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].#subform[0].SSN[0]"
     },
     examDate: {
        value: "",
        dbqName: "form1[0].#subform[0].TextField6[11]"
    },
     docName: {
         value: "",
         dbqName: "form1[0].#subform[11].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "form1[0].#subform[11].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "form1[0].#subform[11].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].#subform[11].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].#subform[11].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].#subform[11].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].#subform[11].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[0].CheckBox36[0]",
            sides: {
                right: "form1[0].#subform[0].#area[0].CheckBox36[1]",
                left: "form1[0].#subform[0].#area[0].CheckBox36[2]",
                both: "form1[0].#subform[0].#area[0].CheckBox36[3]",
                rightDateDbqName: "form1[0].#subform[0].#area[0].TextField6[0]",
                leftDateDbqName: "form1[0].#subform[0].#area[0].TextField6[1]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[1].CheckBox36[4]",
            sides: {
                right: "form1[0].#subform[0].#area[1].CheckBox36[5]",
                left: "form1[0].#subform[0].#area[1].CheckBox36[6]",
                both: "form1[0].#subform[0].#area[1].CheckBox36[7]",
                rightDateDbqName: "form1[0].#subform[0].#area[1].TextField6[2]",
                leftDateDbqName: "form1[0].#subform[0].#area[1].TextField6[3]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[4].CheckBox36[16]",
            sides: {
                right: "form1[0].#subform[0].#area[4].CheckBox36[17]",
                left: "form1[0].#subform[0].#area[4].CheckBox36[18]",
                both: "form1[0].#subform[0].#area[4].CheckBox36[19]",
                rightDateDbqName: "form1[0].#subform[0].#area[4].TextField6[9]",
                leftDateDbqName: "form1[0].#subform[0].#area[4].TextField6[10]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[2].CheckBox36[8]",
            sides: {
                right: "form1[0].#subform[0].#area[2].CheckBox36[9]",
                left: "form1[0].#subform[0].#area[2].CheckBox36[10]",
                both: "form1[0].#subform[0].#area[2].CheckBox36[11]",
                rightDateDbqName: "form1[0].#subform[0].#area[2].TextField6[5]",
                leftDateDbqName: "form1[0].#subform[0].#area[2].TextField6[6]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[3].CheckBox36[12]",
            sides: {
                right: "form1[0].#subform[0].#area[3].CheckBox36[13]",
                left: "form1[0].#subform[0].#area[3].CheckBox36[14]",
                both: "form1[0].#subform[0].#area[3].CheckBox36[15]",
                rightDateDbqName: "form1[0].#subform[0].#area[3].TextField6[7]",
                leftDateDbqName: "form1[0].#subform[0].#area[3].TextField6[8]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[29].CheckBox36[120]",
            sides: {
                right: "form1[0].#subform[1].#area[29].CheckBox36[121]",
                left: "form1[0].#subform[1].#area[29].CheckBox36[122]",
                both: "form1[0].#subform[1].#area[29].CheckBox36[123]",
                rightDateDbqName: "form1[0].#subform[1].#area[29].TextField6[61]",
                leftDateDbqName: "form1[0].#subform[1].#area[29].TextField6[62]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[35].CheckBox36[147]",
            sides: {
                right: "form1[0].#subform[1].#area[35].CheckBox36[148]",
                left: "form1[0].#subform[1].#area[35].CheckBox36[149]",
                both: "form1[0].#subform[1].#area[35].CheckBox36[150]",
                rightDateDbqName: "form1[0].#subform[1].#area[35].TextField6[81]",
                leftDateDbqName: "form1[0].#subform[1].#area[35].TextField6[82]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[5].CheckBox36[24]",
            sides: {
                right: "form1[0].#subform[1].#area[5].CheckBox36[25]",
                left: "form1[0].#subform[1].#area[5].CheckBox36[26]",
                both: "form1[0].#subform[1].#area[5].CheckBox36[27]",
                rightDateDbqName: "form1[0].#subform[1].#area[5].TextField6[12]",
                leftDateDbqName: "form1[0].#subform[1].#area[5].TextField6[13]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[6].CheckBox36[28]",
            sides: {
                right: "form1[0].#subform[1].#area[6].CheckBox36[29]",
                left: "form1[0].#subform[1].#area[6].CheckBox36[30]",
                both: "form1[0].#subform[1].#area[6].CheckBox36[31]",
                rightDateDbqName: "form1[0].#subform[1].#area[6].TextField6[14]",
                leftDateDbqName: "form1[0].#subform[1].#area[6].TextField6[15]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[7].CheckBox36[32]",
            sides: {
                right: "form1[0].#subform[1].#area[7].CheckBox36[33]",
                left: "form1[0].#subform[1].#area[7].CheckBox36[34]",
                both: "form1[0].#subform[1].#area[7].CheckBox36[35]",
                rightDateDbqName: "form1[0].#subform[1].#area[7].TextField6[16]",
                leftDateDbqName: "form1[0].#subform[1].#area[7].TextField6[17]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[36].CheckBox36[151]",
            sides: {
                right: "form1[0].#subform[1].#area[36].CheckBox36[152]",
                left: "form1[0].#subform[1].#area[36].CheckBox36[153]",
                both: "form1[0].#subform[1].#area[36].CheckBox36[154]",
                rightDateDbqName: "form1[0].#subform[1].#area[36].TextField6[83]",
                leftDateDbqName: "form1[0].#subform[1].#area[36].TextField6[84]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[8].CheckBox36[36]",
            sides: {
                right: "form1[0].#subform[1].#area[8].CheckBox36[37]",
                left: "form1[0].#subform[1].#area[8].CheckBox36[38]",
                both: "form1[0].#subform[1].#area[8].CheckBox36[39]",
                rightDateDbqName: "form1[0].#subform[1].#area[8].TextField6[18]",
                leftDateDbqName: "form1[0].#subform[1].#area[8].TextField6[19]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[9].CheckBox36[40]",
            sides: {
                right: "form1[0].#subform[1].#area[9].CheckBox36[41]",
                left: "form1[0].#subform[1].#area[9].CheckBox36[42]",
                both: "form1[0].#subform[1].#area[9].CheckBox36[43]",
                rightDateDbqName: "form1[0].#subform[1].#area[9].TextField6[20]",
                leftDateDbqName: "form1[0].#subform[1].#area[9].TextField6[21]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[16].CheckBox36[68]",
            sides: {
                right: "form1[0].#subform[1].#area[16].CheckBox36[69]",
                left: "form1[0].#subform[1].#area[16].CheckBox36[70]",
                both: "form1[0].#subform[1].#area[16].CheckBox36[71]",
                rightDateDbqName: "form1[0].#subform[1].#area[16].TextField6[34]",
                leftDateDbqName: "form1[0].#subform[1].#area[16].TextField6[35]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[17].CheckBox36[72]",
            sides: {
                right: "form1[0].#subform[1].#area[17].CheckBox36[73]",
                left: "form1[0].#subform[1].#area[17].CheckBox36[74]",
                both: "form1[0].#subform[1].#area[17].CheckBox36[75]",
                rightDateDbqName: "form1[0].#subform[1].#area[17].TextField6[36]",
                leftDateDbqName: "form1[0].#subform[1].#area[17].TextField6[37]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[13].CheckBox36[56]",
            sides: {
                right: "form1[0].#subform[1].#area[13].CheckBox36[57]",
                left: "form1[0].#subform[1].#area[13].CheckBox36[58]",
                both: "form1[0].#subform[1].#area[13].CheckBox36[59]",
                rightDateDbqName: "form1[0].#subform[1].#area[13].TextField6[28]",
                leftDateDbqName: "form1[0].#subform[1].#area[13].TextField6[29]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[14].CheckBox36[60]",
            sides: {
                right: "form1[0].#subform[1].#area[14].CheckBox36[61]",
                left: "form1[0].#subform[1].#area[14].CheckBox36[62]",
                both: "form1[0].#subform[1].#area[14].CheckBox36[63]",
                rightDateDbqName: "form1[0].#subform[1].#area[14].TextField6[30]",
                leftDateDbqName: "form1[0].#subform[1].#area[14].TextField6[31]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[15].CheckBox36[64]",
            sides: {
                right: "form1[0].#subform[1].#area[15].CheckBox36[65]",
                left: "form1[0].#subform[1].#area[15].CheckBox36[66]",
                both: "form1[0].#subform[1].#area[15].CheckBox36[67]",
                rightDateDbqName: "form1[0].#subform[1].#area[15].TextField6[32]",
                leftDateDbqName: "form1[0].#subform[1].#area[15].TextField6[33]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[18].CheckBox36[76]",
            sides: {
                right: "form1[0].#subform[1].#area[18].CheckBox36[77]",
                left: "form1[0].#subform[1].#area[18].CheckBox36[78]",
                both: "form1[0].#subform[1].#area[18].CheckBox36[79]",
                rightDateDbqName: "form1[0].#subform[1].#area[18].TextField6[38]",
                leftDateDbqName: "form1[0].#subform[1].#area[18].TextField6[39]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[19].CheckBox36[80]",
            sides: {
                right: "form1[0].#subform[1].#area[19].CheckBox36[81]",
                left: "form1[0].#subform[1].#area[19].CheckBox36[82]",
                both: "form1[0].#subform[1].#area[19].CheckBox36[83]",
                rightDateDbqName: "form1[0].#subform[1].#area[19].TextField6[40]",
                leftDateDbqName: "form1[0].#subform[1].#area[19].TextField6[41]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[20].CheckBox36[84]",
            sides: {
                right: "form1[0].#subform[1].#area[20].CheckBox36[85]",
                left: "form1[0].#subform[1].#area[20].CheckBox36[86]",
                both: "form1[0].#subform[1].#area[20].CheckBox36[87]",
                rightDateDbqName: "form1[0].#subform[1].#area[20].TextField6[42]",
                leftDateDbqName: "form1[0].#subform[1].#area[20].TextField6[43]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[21].CheckBox36[88]",
            sides: {
                right: "form1[0].#subform[1].#area[21].CheckBox36[89]",
                left: "form1[0].#subform[1].#area[21].CheckBox36[90]",
                both: "form1[0].#subform[1].#area[21].CheckBox36[91]",
                rightDateDbqName: "form1[0].#subform[1].#area[21].TextField6[44]",
                leftDateDbqName: "form1[0].#subform[1].#area[21].TextField6[45]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[22].CheckBox36[92]",
            sides: {
                right: "form1[0].#subform[1].#area[22].CheckBox36[93]",
                left: "form1[0].#subform[1].#area[22].CheckBox36[94]",
                both: "form1[0].#subform[1].#area[22].CheckBox36[95]",
                rightDateDbqName: "form1[0].#subform[1].#area[22].TextField6[46]",
                leftDateDbqName: "form1[0].#subform[1].#area[22].TextField6[47]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[23].CheckBox36[96]",
            sides: {
                right: "form1[0].#subform[1].#area[23].CheckBox36[97]",
                left: "form1[0].#subform[1].#area[23].CheckBox36[98]",
                both: "form1[0].#subform[1].#area[23].CheckBox36[99]",
                rightDateDbqName: "form1[0].#subform[1].#area[23].TextField6[48]",
                leftDateDbqName: "form1[0].#subform[1].#area[23].TextField6[49]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[10].CheckBox36[44]",
            sides: {
                right: "form1[0].#subform[1].#area[10].CheckBox36[45]",
                left: "form1[0].#subform[1].#area[10].CheckBox36[46]",
                both: "form1[0].#subform[1].#area[10].CheckBox36[47]",
                rightDateDbqName: "form1[0].#subform[1].#area[10].TextField6[22]",
                leftDateDbqName: "form1[0].#subform[1].#area[10].TextField6[23]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[11].CheckBox36[48]",
            sides: {
                right: "form1[0].#subform[1].#area[11].CheckBox36[49]",
                left: "form1[0].#subform[1].#area[11].CheckBox36[50]",
                both: "form1[0].#subform[1].#area[11].CheckBox36[51]",
                rightDateDbqName: "form1[0].#subform[1].#area[11].TextField6[24]",
                leftDateDbqName: "form1[0].#subform[1].#area[11].TextField6[25]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[12].CheckBox36[52]",
            sides: {
                right: "form1[0].#subform[1].#area[12].CheckBox36[53]",
                left: "form1[0].#subform[1].#area[12].CheckBox36[54]",
                both: "form1[0].#subform[1].#area[12].CheckBox36[55]",
                rightDateDbqName: "form1[0].#subform[1].#area[12].TextField6[26]",
                leftDateDbqName: "form1[0].#subform[1].#area[12].TextField6[27]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[24].CheckBox36[100]",
            sides: {
                right: "form1[0].#subform[1].#area[24].CheckBox36[101]",
                left: "form1[0].#subform[1].#area[24].CheckBox36[102]",
                both: "form1[0].#subform[1].#area[24].CheckBox36[103]",
                rightDateDbqName: "form1[0].#subform[1].#area[24].TextField6[51]",
                leftDateDbqName: "form1[0].#subform[1].#area[24].TextField6[52]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[25].CheckBox36[104]",
            sides: {
                right: "form1[0].#subform[1].#area[25].CheckBox36[105]",
                left: "form1[0].#subform[1].#area[25].CheckBox36[106]",
                both: "form1[0].#subform[1].#area[25].CheckBox36[107]",
                rightDateDbqName: "form1[0].#subform[1].#area[25].TextField6[53]",
                leftDateDbqName: "form1[0].#subform[1].#area[25].TextField6[54]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[26].CheckBox36[108]",
            sides: {
                right: "form1[0].#subform[1].#area[26].CheckBox36[109]",
                left: "form1[0].#subform[1].#area[26].CheckBox36[110]",
                both: "form1[0].#subform[1].#area[26].CheckBox36[111]",
                rightDateDbqName: "form1[0].#subform[1].#area[26].TextField6[55]",
                leftDateDbqName: "form1[0].#subform[1].#area[26].TextField6[56]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[27].CheckBox36[112]",
            sides: {
                right: "form1[0].#subform[1].#area[27].CheckBox36[113]",
                left: "form1[0].#subform[1].#area[27].CheckBox36[114]",
                both: "form1[0].#subform[1].#area[27].CheckBox36[115]",
                rightDateDbqName: "form1[0].#subform[1].#area[27].TextField6[57]",
                leftDateDbqName: "form1[0].#subform[1].#area[27].TextField6[58]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[28].CheckBox36[116]",
            sides: {
                right: "form1[0].#subform[1].#area[28].CheckBox36[117]",
                left: "form1[0].#subform[1].#area[28].CheckBox36[118]",
                both: "form1[0].#subform[1].#area[28].CheckBox36[119]",
                rightDateDbqName: "form1[0].#subform[1].#area[28].TextField6[59]",
                leftDateDbqName: "form1[0].#subform[1].#area[28].TextField6[60]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].CheckBox36[158]",
            sides: {
                right: "form1[0].#subform[1].#area[30].CheckBox36[124]",
                left: "form1[0].#subform[1].#area[30].CheckBox36[125]",
                both: "form1[0].#subform[1].#area[30].CheckBox36[126]",
                rightDateDbqName: "form1[0].#subform[1].#area[30].TextField6[63]",
                leftDateDbqName: "form1[0].#subform[1].#area[30].TextField6[64]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].CheckBox36[157]",
            sides: {
                right: "form1[0].#subform[1].#area[33].CheckBox36[133]",
                left: "form1[0].#subform[1].#area[33].CheckBox36[134]",
                both: "form1[0].#subform[1].#area[33].CheckBox36[135]",
                rightDateDbqName: "form1[0].#subform[1].#area[33].TextField6[69]",
                leftDateDbqName: "form1[0].#subform[1].#area[33].TextField6[70]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].CheckBox36[156]",
            sides: {
                right: "form1[0].#subform[1].#area[32].CheckBox36[130]",
                left: "form1[0].#subform[1].#area[32].CheckBox36[131]",
                both: "form1[0].#subform[1].#area[32].CheckBox36[132]",
                rightDateDbqName: "form1[0].#subform[1].#area[32].TextField6[67]",
                leftDateDbqName: "form1[0].#subform[1].#area[32].TextField6[68]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].CheckBox36[155]",
            sides: {
                right: "form1[0].#subform[1].#area[31].CheckBox36[127]",
                left: "form1[0].#subform[1].#area[31].CheckBox36[128]",
                both: "form1[0].#subform[1].#area[31].CheckBox36[129]",
                rightDateDbqName: "form1[0].#subform[1].#area[31].TextField6[65]",
                leftDateDbqName: "form1[0].#subform[1].#area[31].TextField6[66]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].#area[34].CheckBox36[136]",
            sides: {
                right: "form1[0].#subform[1].#area[34].CheckBox36[137]",
                left: "form1[0].#subform[1].#area[34].CheckBox36[138]",
                both: "form1[0].#subform[1].#area[34].CheckBox36[139]",
                rightDateDbqName: "form1[0].#subform[1].#area[34].TextField6[71]",
                leftDateDbqName: "form1[0].#subform[1].#area[34].TextField6[72]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[1].TextField6[74]",
            sides: {
                right: "form1[0].#subform[1].CheckBox36[141]",
                left: "form1[0].#subform[1].CheckBox36[142]",
                both: "form1[0].#subform[1].CheckBox36[143]",
                rightDateDbqName: "form1[0].#subform[1].TextField6[75]",
                leftDateDbqName: "form1[0].#subform[1].TextField6[76]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[1].TextField6[77]",
            sides: {
                right: "form1[0].#subform[1].CheckBox36[144]",
                left: "form1[0].#subform[1].CheckBox36[145]",
                both: "form1[0].#subform[1].CheckBox36[146]",
                rightDateDbqName: "form1[0].#subform[1].TextField6[78]",
                leftDateDbqName: "form1[0].#subform[1].TextField6[79]"
            },
        }     
    ]
}

export default ssn ;